import React from 'react'
import { api } from '../api'
import BaseLayout from '../layouts/BaseLayout'
import BannerSlideCard from '../components/ui-kit/cards/BannerSliderCard'
import { ProjectsSection, SocialNetworksSection, SolutionsSections } from '../components/home';
import { GetStaticProps } from 'next';
import HomeJumbotron from '../components/_general/jumbotron/HomeJumbotron';
import SolutionService from '../services/SolutionService';
import CallToActionBox from '../components/ui-kit/call-to-actions/CallToActionBox';
import ProjectService from '../services/ProjectService';
import { DEFAULT_SEO_HEAD } from '../constants';

const slides = [
	{
		title: "En Codealo vas a encontrar ideas de proyectos de todos los lenguajes y para el tipo de programador que quieres ser. 🤓",
		details: <>Empezar es fácil, solo sigue <br />los siguientes pasos:</>,
		image: "/imgs/slide_01.png",
		imageAlt: 'Slider 1 alt'
	},
]
const Index = ({ projects, solutions }) => {
	return (
		<BaseLayout seo={DEFAULT_SEO_HEAD} title="Bienvenido a Codealo 👋" search>
			<HomeJumbotron />
			<ProjectsSection projects={projects} />
			<CallToActionBox
				body="Sube tu solución a un proyecto y obtén comentarios constructivos de la comunidad"
				btnText="Encontrar mi primer proyecto"
				href="/proyectos"
			/>
			<SolutionsSections solutions={solutions} />
			<SocialNetworksSection />
		</BaseLayout>
	)
}

export const getStaticProps: GetStaticProps = async (context) => {
	try {
		const { data: projects } = await ProjectService.getProjects({ _publicationState: 'preview' });
		const { data: solutions } = await SolutionService.getAll({ 'completed_at_null': false });

		return {
			props: {
				projects,
				solutions
			},
			revalidate: 60,
		};
	} catch (err) {
		return {
			props: {
				projects: [],
				filter: {},
			},
			revalidate: 60,
		};
	}
};



export default Index;